import { AssignmentRoles } from 'bundles/compound-assessments/types/Roles';
import type { AssignmentRole } from 'bundles/compound-assessments/types/Roles';

export const SimilarityCheckRoles = {
  GRADER: 'grader',
  LEARNER: 'learner',
} as const;

export type SimilarityCheckRole = typeof SimilarityCheckRoles[keyof typeof SimilarityCheckRoles];

export function getUseDraftFromSimilarityCheckRole(role: SimilarityCheckRole) {
  return role !== SimilarityCheckRoles.GRADER;
}

export function getSimilarityCheckRoleFromAssignmentRole(role?: AssignmentRole): SimilarityCheckRole {
  return role === AssignmentRoles.GRADER ? SimilarityCheckRoles.GRADER : SimilarityCheckRoles.LEARNER;
}
